import { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Alert from "@mui/material/Alert";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

import { ApiUrl } from "../config/api_url";
import Logo from "../assets/liyulogo.png";

export default function SignupForm() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");

  const [isError, setIsError] = useState({ value: false, message: "" });

  const onSubmit = (e) => {
    e.preventDefault();

    if (!firstName || !lastName || !phoneNumber || !password) {
      setIsError({
        value: true,
        message: "All required fields must be filled!",
      });
      return;
    }

    setIsLoading(true);

    axios
      .post(
        `${ApiUrl}/customers/auth/signup`,
        {
          firstName,
          lastName,
          phoneNumber,
          password,
          email: email || undefined, // optional
        },
        {
          headers: {
            "x-api-key": "zR0ClHzLGi",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          history.push("/verify-otp"); // redirect after signup
        } else {
          setIsError({
            value: true,
            message: res.data.message || "Signup failed",
          });
        }
      })
      .catch((err) =>
        setIsError({
          value: true,
          message: err.response?.data?.message || err.message,
        })
      )
      .finally(() => setIsLoading(false));
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ padding: { xs: 2, sm: 4 }, mt: 10 }}>
        <Avatar
          alt="Liyu bus"
          src={Logo}
          sx={{ width: 100, height: 100, mx: "auto" }}
        />

        <Typography
          variant="h5"
          component="h4"
          gutterBottom
          align="center"
          mt={3}
        >
          Create Liyu Bus Customer Account
        </Typography>

        <form onSubmit={onSubmit}>
          <Stack alignItems="center" spacing={3}>
            {isError.value && <Alert severity="error">{isError.message}</Alert>}

            <TextField
              fullWidth
              label="First Name"
              variant="standard"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />

            <TextField
              fullWidth
              label="Last Name"
              variant="standard"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />

            <TextField
              fullWidth
              type="text"
              label="Phone Number"
              variant="standard"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />

            <TextField
              fullWidth
              type="password"
              label="Password"
              variant="standard"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <TextField
              fullWidth
              type="email"
              label="Email (optional)"
              variant="standard"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={isLoading}
            >
              {isLoading ? "Signing up..." : "Sign Up"}
            </Button>

            <Typography variant="body2" align="center">
              Already have an account? <Link to="/login">Login</Link>
            </Typography>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
}
